export default [
    {
        name: 'Splendid Wren',
        ID: 1,
    },
    {
        name: 'Splendid Wren Couple',
        ID: 2,
    },
    {
        name: 'Splendid Wren Family',
        ID: 3,
    },
    {
        name: 'Red-winged Wren',
        ID: 4,
    },
    {
        name: 'Red-tailed Black Cockatoo',
        ID: 5,
    },
    {
        name: 'Laughing Kookaburra',
        ID: 6,
    },
    {
        name: 'Twenty-eight Parrot',
        ID: 7,
    },
    {
        name: 'Galah',
        ID: 8,
    },
    {
        name: 'Red-capped Robin',
        ID: 9,
    },
    {
        name: 'Willie Wagtail',
        ID: 10,
    },
    {
        name: 'Western Magpie',
        ID: 11,
    },
    {
        name: 'Barn Owl',
        ID: 12,
    },
    {
        name: 'Scarlet Robin',
        ID: 13,
    },
    {
        name: 'Red-eared Firetail Finch',
        ID: 14,
    },
    {
        name: 'Western Rosella',
        ID: 15,
    },
    {
        name: 'Red-Capped Robin', //Second listing
        ID: 16,
    },
    {
        name: 'Golden Bronze Cuckoo',
        ID: 17,
    },
    {
        name: 'Red-eared Firetail Finch', //Second listing
        ID: 18,
    },
    {
        name: 'Coaster Set Image A',
        ID: 19,
    },
    {
        name: 'Coaster Set Image B',
        ID: 20,
    },
];
